export const formatPrice = (price = 0, { numDecimals = 0 } = {}) => parseFloat(price / Math.pow(10, numDecimals));
